import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { useNavigate, useLocation } from 'react-router-dom'
import { useLeftNavStore } from './left-nav-store'
import type { NavSection } from './types'

const NavItemWrapper = styled.li`
  margin: 0;
  padding: 0;
`

const NavItemButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 36px;
  padding: 0 4px 0 20px;
  border: none;
  background: ${({ $isActive }) => ($isActive ? '#A5BEAF' : 'transparent')};
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease-in-out;

  &:hover {
    background: ${({ $isActive }) =>
      $isActive ? '#A5BEAF' : 'rgba(165, 190, 175, 0.5)'};
  }
`

const NavItemLabel = styled.span<{ $isActive: boolean }>`
  font-size: 14px;
  font-weight: ${({ $isActive }) => ($isActive ? '700' : '500')};
  color: #191d23;
  line-height: 1.4;
`

interface SlideOutNavItemProps {
  label: string
  path: string
  section?: NavSection
  onClick?: () => void
}

export const SlideOutNavItem: React.FC<SlideOutNavItemProps> = ({
  label,
  path,
  section,
  onClick,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { setLastVisited, closeSlideOut } = useLeftNavStore()

  const isActive =
    location.pathname === path || location.pathname.startsWith(`${path}/`)

  const handleClick = useCallback(() => {
    navigate(path)
    // Track the last visited path for this section
    if (section) {
      setLastVisited(section, path)
    }
    // Close the slide-out after navigation
    closeSlideOut()
    onClick?.()
  }, [navigate, path, section, setLastVisited, closeSlideOut, onClick])

  return (
    <NavItemWrapper>
      <NavItemButton
        $isActive={isActive}
        onClick={handleClick}
        aria-current={isActive ? 'page' : undefined}
      >
        <NavItemLabel $isActive={isActive}>{label}</NavItemLabel>
      </NavItemButton>
    </NavItemWrapper>
  )
}
